import {gql} from "@apollo/client";

const resetPasswordMutation = gql`
    mutation ResetPasswordMutation($password: String, $token: String, $userId: String) {
        resetPasswordV2(userId: $userId, password: $password, token: $token) {
            error
            success
            redirectUrl
        }
    }
`;

export default resetPasswordMutation;
